import { render } from "./PaymentTermV2.vue.ts?vue&type=template&id=c10d1b9a&scoped=true&ts=true!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./PaymentTermV2.vue?vue&type=template&id=c10d1b9a&scoped=true&ts=true"
import script from "./PaymentTermV2.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./PaymentTermV2.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaymentTermV2.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./PaymentTermV2.vue?vue&type=script&setup=true&lang=ts"

import "./PaymentTermV2.vue.scss?vue&type=style&index=0&id=c10d1b9a&lang=scss&scoped=true!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./PaymentTermV2.vue?vue&type=style&index=0&id=c10d1b9a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c10d1b9a"],['__file',"src/apps/merchant3/components/offers/payment-terms/PaymentTermV2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c10d1b9a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c10d1b9a', __exports__)) {
    api.reload('c10d1b9a', __exports__)
  }
  
  module.hot.accept("./PaymentTermV2.vue.ts?vue&type=template&id=c10d1b9a&scoped=true&ts=true!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./PaymentTermV2.vue?vue&type=template&id=c10d1b9a&scoped=true&ts=true", () => {
    api.rerender('c10d1b9a', render)
  })

}


export default __exports__